export default class Response {
    public Status: boolean;
    public Data: any;
    public Messages: string;
    public Exception: string;
    public ExceptionStatusCode: number;

    constructor(status: boolean, data: any, mess: string, exception: string, exceptionStatusCode: number) {
        this.Status = status;
        this.Data = data;
        this.Messages = mess;
        this.Exception = exception;
        this.ExceptionStatusCode = exceptionStatusCode;
    }

}